export default __webpack_public_path__ + "static/media/thumbnail.0c7c1a94.png";